import { Link } from "react-router-dom";


const SocialServiceCard = () => {

    const certificates = [
        {
            title: "Certificate 1",
            body: "",
            link: "./certificates/1",
            color: "primary",
            image: "",
            icon: "bx bx-error",
        },
        {
            title: "Certificate 2",
            body: "",
            link: "./certificates/2",
            color: "warning",
            image: "",
            icon: "bx bx-error",
        },
        {
            title: "Certificate 3",
            body: "",
            link: "certificates/3",
            color: "danger",
            image: "",
            icon: "bx bx-git-repo-forked",
        },
        {
            title: "Certificate 4",
            body: "",
            link: "/4",
            color: "info",
            image: "",
            icon: "bx bx-time-five",
        }
    ];

    return (
        <>



            <div className="row">


             



                {certificates.map((item, index) => (
                    <div key={index} className="col-sm-6 col-lg-3 mb-4">
                        <div className={`card card-border-shadow-${item.color} h-100`}>
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-2 pb-1">
                                    <div className="avatar me-2">
                                        <span className={`avatar-initial rounded bg-label-${item.color}`}><i className={item.icon} /></span>
                                    </div>
                                    <h4 className="ms-1 mb-0">NA</h4>
                                </div>
                                <p className="mb-1">{item.title}</p>
                                <p className="mb-0">
                                    <span className="fw-medium me-1">NA</span>
                                    <Link to={`/${item.link}`} ><small className="text-muted">than last week</small></Link>
                                </p>
                            </div>
                        </div>
                    </div>
                ))}

               

            </div>
        </>
    );
}

export default SocialServiceCard;